import type { State } from '../../types';
import type { AssetViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function assetsNotDeleted(state: State): AssetViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.assetsById).filter(function (e) {
    return !e.deleted;
  });
}
